<template lang="html">
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card title="Add New User" class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Add New User</h4>
                    </div>
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Save</vs-button>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col md:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Username*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="form.username" />
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Email*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="form.email" />
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Password*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="form.password" type="password"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                User Group*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample"
                                    v-model="form.user_group_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, usergroup)"
                                >
                                    <vs-select-item v-for="(item, index) in usergroup.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                User Type*
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select
                                    :options="userTypeOptions"
                                    v-model="form.user_type_id"
                                    :reduce="option => option.value"
                                    class="mb-3"
                                    :clearable="false"
                                ></v-select> -->
                                <vs-select
                                    class="selectExample"
                                    v-model="form.user_type"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, userTypeOptions)"
                                >
                                    <vs-select-item v-for="(item, index) in userTypeOptions" :key="index" :value="item.value" :text="item.label"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Status*
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select
                                    :options="statusOptions"
                                    v-model="form.status"
                                    :reduce="option => option.value"
                                    class="mb-3"
                                    :clearable="false"
                                ></v-select> -->
                                <vs-select
                                    class="selectExample"
                                    v-model="form.status"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, statusOptions)"
                                >
                                    <vs-select-item v-for="(item, index) in statusOptions" :key="index" :value="item.value" :text="item.label"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Client*
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select
                                    :options="clientOptions"
                                    v-model="form.client_id"
                                    :reduce="option => option.value"
                                    class="mb-3"
                                    :disabled="form.user_type_id == 'Regular'"
                                ></v-select> -->
                                <vs-select
                                    class="selectExample"
                                    v-model="form.client_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, client)"
                                    :disabled="form.user_type == 'Regular'"
                                    :clearable="false"
                                >
                                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-divider border-style="solid">form</vs-divider>
                <div class="vx-row mt-6">
                    <div class="vx-col md:w-1/4 w-full">
                        <div class="vx-row mb-3" @mouseleave="show = !show">
                            <div class="vx-col w-1/3">
                                Clients Access*
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select
                                    :options="clientAccessOptions"
                                    v-model="access.clients"
                                    :reduce="option => option.value"
                                    @input="limiter"
                                    multiple
                                ></v-select> -->
                                <vs-select
                                    class="selectExample"
                                    v-model="form.clients"
                                    width="100%"
                                    label-placeholder="Autocomplete"
                                    multiple
                                    autocomplete
                                    :clearable="true"
                                    @input="limiter()"
                                >
                                    <vs-select-item v-for="(item, index) in clientAccessOptions" 
                                    :key="index" :value="item.value" :text="item.label" v-show="show"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3" style="margin-top: 25px">
                            <div class="vx-col w-1/3">
                                Client Default
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select 
                                :options="clientDefaultOptions" 
                                v-model="form.default_client_id" 
                                :reduce="option => option.value">
                                </v-select> -->
                                <vs-select
                                    class="selectExample"
                                    v-model="form.default_client_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, clientDefaultOptions)"
                                >
                                    <vs-select-item v-for="(item, index) in clientDefaultOptions" :key="index" :value="item.value" :text="item.label"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Origin ID
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select :options="customerOptions" v-model="form.origin_id" :reduce="option => option.value"></v-select> -->
                                <vs-select
                                    class="selectExample"
                                    v-model="form.origin_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, origin)"
                                >
                                    <vs-select-item v-for="(item, index) in origin.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Destination ID
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select :options="customerOptions" v-model="form.destination_id" :reduce="option => option.value"></v-select> -->
                                <vs-select
                                    class="selectExample"
                                    v-model="form.destination_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, destination)"
                                >
                                    <vs-select-item v-for="(item, index) in destination.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Supplier ID
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select :options="customerOptions" v-model="form.supplier_id" :reduce="option => option.value"></v-select> -->
                                 <vs-select
                                    class="selectExample"
                                    v-model="form.supplier_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, supplier)"
                                >
                                    <vs-select-item v-for="(item, index) in supplier.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-full">
                        <div class="vx-row mb-3" @mouseleave="show = !show">
                            <div class="vx-col w-1/3">
                                Warehouses Access*
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select multiple :options="warehousesOptions" v-model="access.warehouses" :clearable="false" @input="whlimiter" :reduce="option => option.value"></v-select> -->
                                <vs-select
                                    class="selectExample"
                                    v-model="form.warehouses"
                                    width="100%"
                                    label-placeholder="Autocomplete"
                                    multiple
                                    autocomplete
                                    :clearable="true"
                                    @input="whlimiter()"
                                >
                                    <vs-select-item v-for="(item, index) in warehousesOptions" :key="index" :value="item.value" :text="item.label" v-show="show"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3" style="margin-top: 25px">
                            <div class="vx-col w-1/3">
                                Warehouse Default
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select :options="warehouseDefaultOptions" v-model="form.warehouse_id" :reduce="option => option.value"></v-select> -->
                                <vs-select
                                    class="selectExample"
                                    v-model="form.warehouse_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, warehouseDefaultOptions)"
                                >
                                    <vs-select-item v-for="(item, index) in warehouseDefaultOptions" :key="index" :value="item.value" :text="item.label"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Inbound Type
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select :options="orderTypeOptions" v-model="form.inbound_type_id" :reduce="option => option.value"></v-select> -->
                                 <vs-select
                                    class="selectExample"
                                    v-model="form.inbound_type_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, inbound_type)"
                                >
                                    <vs-select-item v-for="(item, index) in inbound_type.data" :key="index" :value="item.id" :text="item.order_type"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Outbound Type
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select :options="orderTypeOptions" v-model="form.outbound_type_id" :reduce="option => option.value"></v-select> -->
                                 <vs-select
                                    class="selectExample"
                                    v-model="form.outbound_type_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, outbound_type)"
                                >
                                    <vs-select-item v-for="(item, index) in outbound_type.data" :key="index" :value="item.id" :text="item.order_type"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Base UoM
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select :options="uomOptions" v-model="form.base_uom_id" :reduce="option => option.value"></v-select> -->
                                <vs-select
                                    class="selectExample"
                                    v-model="form.base_uom_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, base_uom)"
                                >
                                    <vs-select-item v-for="(item, index) in base_uom.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Part UoM
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select :options="uomOptions" v-model="form.part_uom_id" :reduce="option => option.value"></v-select> -->
                                <vs-select
                                    class="selectExample"
                                    v-model="form.part_uom_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, part_uom)"
                                >
                                    <vs-select-item v-for="(item, index) in part_uom.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Unit Weight
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select :options="access.clients" v-model="form.client_id" :reduce="option => option.value"></v-select> -->
                                <vs-select
                                    class="selectExample"
                                    v-model="form.unit_weight_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, unit_weight)"
                                >
                                    <vs-select-item v-for="(item, index) in unit_weight.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Section
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select :options="sectionOptions" v-model="form.section_id" :reduce="option => option.value"></v-select> -->
                                <vs-select
                                    class="selectExample"
                                    v-model="form.section_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, section)"
                                >
                                    <vs-select-item v-for="(item, index) in section.data" :key="index" :value="item.id" :text="item.section_code"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Currency
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample"
                                    v-model="form.currency_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, currency)"
                                >
                                    <vs-select-item v-for="(item, index) in currency.data" :key="index" :value="item.id" :text="item.currency_code"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Stock Type
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select :options="stockTypeOptions" v-model="form.stock_type_id" :reduce="option => option.value"></v-select> -->
                                <vs-select
                                    class="selectExample"
                                    v-model="form.stock_type_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, stock_type)"
                                >
                                    <vs-select-item v-for="(item, index) in stock_type.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3" >
                            <div class="vx-col w-1/3">
                                Product Category
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select :options="productCategoryOptions" v-model="form.product_categories_id" :reduce="option => option.value"></v-select> -->
                                <vs-select 
                                    class="selectExample"
                                    v-model="form.product_categories_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, product_category)"
                                >
                                    <vs-select-item 
                                    v-for="(item, index) in product_category.data" 
                                    :key="index" :value="item.id" :text="item.name" />
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Unit Volume
                            </div>
                            <div class="vx-col w-2/3">
                                <!-- <v-select :options="access.clients" v-model="form.client_id" :reduce="option => option.value"></v-select> -->
                                <vs-select
                                    class="selectExample"
                                    v-model="form.unit_volume_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, unit_volume)"
                                >
                                    <vs-select-item class="" v-for="(item, index) in unit_volume.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                </div>
            </vs-card>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import { AgGridVue } from "ag-grid-vue";

	export default {
		components:{
            vSelect,
            AgGridVue
		},
		data(){
			return {
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true
                },
                isLoading: false,
                // access: {
                //     clients: [],
                //     warehouses: []
                // },
                show: true,
                form: {
                    clients: [],
                    warehouses: [],
                    username: '',
                    email: '',
                    password: '',
                    user_group_id: null,
                    client_id: null,
                    user_type: 'Regular',
                    status: 1,
                    // client_id: null,
                    default_client_id: null,
                    warehouse_id: null,
                    origin_id: null,
                    destination_id: null,
                    supplier_id: null,
                    inbound_type_id: null,
                    outbound_type_id: null,
                    section_id: null,
                    base_uom_id: null,
                    part_uom_id: null,
                    unit_weight_id: null,
                    unit_volume_id: null,
                    currency_id: null,
                    stock_type_id: null,
                    product_categories_id: null
                },
                userTypeOptions: [
                    {
                        value: 'Regular',
                        label: 'Regular'
                    }, 
                    {
                        value: 'Client',
                        label: 'Client'
                    }
                ],
                usergroup: {
                    data: [],
                    loading: false,
                    endpoint: 'rolemanagement/usergroup', 
                    objectKey: 'name'
                },
                origin: {
                    data: [],
                    loading: false,
                    endpoint: 'master/customers', 
                    objectKey: 'name'
                },
                destination: {
                    data: [],
                    loading: false,
                    endpoint: 'master/customers', 
                    objectKey: 'name'
                },
                currency: {
                    data: [],
                    loading: false,
                    endpoint: 'master/currency', 
                    objectKey: 'currency_code'
                },
                supplier: {
                    data: [],
                    loading: false,
                    endpoint: 'master/customers', 
                    objectKey: 'name'
                },
                client: {
                    data: [],
                    loading: false,
                    endpoint: 'master/clients', 
                    objectKey: 'name'
                },
                client_default: {
                    data: [],
                    loading: false,
                    endpoint: 'master/clients', 
                    objectKey: 'name'
                },
                inbound_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/ordertypes', 
                    objectKey: 'order_type'
                },
                outbound_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/ordertypes', 
                    objectKey: 'order_type'
                },
                base_uom: {
                    data: [],
                    loading: false,
                    endpoint: 'master/uom', 
                    objectKey: 'name'
                },
                part_uom: {
                    data: [],
                    loading: false,
                    endpoint: 'master/uom', 
                    objectKey: 'name'
                },
                part_uom: {
                    data: [],
                    loading: false,
                    endpoint: 'master/uom', 
                    objectKey: 'name'
                },
                unit_weight: {
                    data: [],
                    loading: false,
                    endpoint: 'master/uow', 
                    objectKey: 'name'
                },
                section: {
                    data: [],
                    loading: false,
                    endpoint: 'master/sections', 
                    objectKey: 'section_code'
                },
                stock_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/stocktypes', 
                    objectKey: 'name'
                },
                product_category: {
                    data: [],
                    loading: false,
                    endpoint: 'master/productcategories', 
                    objectKey: 'name'
                },
                unit_volume: {
                    data: [],
                    loading: false,
                    endpoint: 'master/uov', 
                    objectKey: 'name'
                },
                clientOptions: [],
                clientAccessOptions: [],
                clientDefaultOptions: [],
                statusOptions: [
                    {
                        value: 1,
                        label: 'Active'
                    },
                    {
                        value: 0,
                        label: 'Deactive'
                    }
                ],
                customerOptions: [],
                warehousesOptions: [],
                warehouseDefaultOptions: [],
                customerOptions: [],
                orderTypeOptions: [],
                sectionOptions: [],
                uomOptions: [],
                productCategoryOptions: [],
                stockTypeOptions: []
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            },
            user: {
                deep: true,
                handler: function(data) {
                    data.client = data.user_type == 'Regular' ? null : data.client
                }
            }
        },
        methods:{
            fetchData() {
                this.isLoading = true

                Promise.all([
                this.$http.post('rolemanagement/usergroup'), 
                this.$http.post('master/clients'), 
                this.$http.post('master/warehouses'), 
                this.$http.post('master/customers'), 
                this.$http.post('master/ordertypes'), 
                this.$http.post('master/sections'), 
                this.$http.post('master/uom'), 
                this.$http.post('master/uow'), 
                this.$http.post('master/uov'), 
                this.$http.post('master/productcategories'), 
                this.$http.post('master/stocktypes'),
                this.$http.post('master/currency')
                ])
                .then(
                    this.$http.spread(
                        (usergroups, clients, warehouses, customers, ordertypes, sections, uoms, uows, uovs, productcategories, stocktypes, currency) => {
                    this.usergroup.data = usergroups.data.data;
                    this.client.data = clients.data.data;
                    this.client_default.data = clients.data.data;
                    // warehouses.data.data.map(warehouse => {
                    //     this.warehousesOptions.push({
                    //         value: warehouse.id,
                    //         label: warehouse.warehouses_code
                    //     })
                    // });
                    this.origin.data = customers.data.data;
                    this.destination.data = customers.data.data;
                    this.supplier.data = customers.data.data;
                    this.inbound_type.data = ordertypes.data.data;
                    this.outbound_type.data = ordertypes.data.data;
                    this.base_uom.data = uoms.data.data;
                    this.part_uom.data = uoms.data.data;
                    this.unit_weight.data = uows.data.data;
                    this.section.data = sections.data.data;
                    this.stock_type.data = stocktypes.data.data;
                    this.unit_volume.data = uovs.data.data;
                    this.product_category.data = productcategories.data.data;
                    this.currency.data = currency.data;
                    // this.warehouseDefaultOptions = warehouses.data.data;
                    // this.client_default = clientdefaults.data.data;


                    // usergroups.data.data.map(usergroup => {
                    //     this.userGroupOptions.push({
                    //         value: usergroup.id,
                    //         label: usergroup.name
                    //     })
                    // })

                    // clients.data.data.map((client, clientdefault) => {
                    //     this.client.data.push({
                    //         value: client.id,
                    //         label: client.client_code
                    //     })
                    // }); 

                    // clients.data.data.map(clientdefault => {

                    //     this.client_default.data.push({
                    //         value: clientdefault.id,
                    //         label: clientdefault.client_code
                    //     })
                    // });

                    this.clientAccessOptions.unshift({
                        value: 'All',
                        label: 'All'
                    });

                    warehouses.data.data.map(warehouse => {
                        this.warehousesOptions.push({
                            value: warehouse.id,
                            label: warehouse.warehouses_code
                        })
                    });
                    clients.data.data.map(client => {
                        this.clientAccessOptions.push({
                            value: client.id,
                            label: client.client_code
                        })
                    });

                    this.warehousesOptions.unshift({
                        value: 'All',
                        label: 'All'
                    });

                    // customers.data.data.map(customer => {
                    //     this.origin.data.push({
                    //         value: customer.id,
                    //         label: customer.name
                    //     })
                
                    // });
                    // customers.data.data.map(destination => {
        
                    //     this.destination.data.push({
                    //         value: destination.id,
                    //         label: destination.name
                    //     })
                    // });

                    // ordertypes.data.data.map(ordertype => {
                    //     this.orderTypeOptions.push({
                    //         value: ordertype.id,
                    //         label: ordertype.order_type
                    //     })
                    // });

                    sections.data.data.map(section => {
                        this.sectionOptions.push({
                            value: section.id,
                            label: section.section_code
                        })
                    });

                    // uoms.data.data.map(uom => {
                    //     this.uomOptions.push({
                    //         value: uom.id,
                    //         label: uom.name
                    //     })
                    // });
                    
                    productcategories.data.data.map(productcategory => {
                        this.productCategoryOptions.push({
                            value: productcategory.id,
                            label: productcategory.name
                        })
                    });

                    stocktypes.data.data.map(stocktype => {
                        this.stockTypeOptions.push({
                            value: stocktype.id,
                            label: stocktype.name
                        })
                    });

                    this.isLoading = false;
                }))
                .catch(error => {
                    this.isLoading = false
                })
            },
            submitForm() {
                // this.form.client_id = this.form.client_id.id
                // console.log(this.form)
                // console.log(this.user)
                this.isLoading = true;
                if(this.form.user_type = 'Regular'){
                    this.form.client_id = null;
                }
                this.$http
                    .post("rolemanagement/users/store", this.form)
                    .then(res => {
                    this.isLoading = false;
                    this.$router.push({ path: "/user" });
                    this.fetchData();
                    const message = res.data.message ? res.data.message : 'Success.'
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            iconPack: "feather",
                            icon: "icon-check",
                            text: message
                        });
                    })
                    .catch(error => this.handleError(error));
            },
            back() {
                this.$vs.dialog({
                    color: 'warning',
                    title: 'Leave Page',
                    text: 'Changes you made may not be saved',
                    acceptText: 'Leave Page',
                    accept: () => this.$router.go(-1),
                })
            },
            limiter() {
                this.clientDefaultOptions = [];
                this.form.default_client_id = null;
                if(this.form.clients.findIndex((a) => a == 'All') !== -1) {
                    this.form.clients = ['All'];

                    this.clientAccessOptions.map(c => c.label != 'All' ? this.clientDefaultOptions.push(c) : false);

                }
                else {
                    const form = []
                    this.clientAccessOptions.map(c => {
                        this.form.clients.map(a => {
                            if(a == c.value) {
                                form.push(c)
                            }
                        })
                    })

                    this.clientDefaultOptions = form;
                }
            },
            whlimiter() {
                this.warehouseDefaultOptions = []
                this.form.warehouse_id = null
                if(this.form.warehouses.findIndex(a => a == 'All') !== -1) {
                    this.form.warehouses = ['All']

                    this.warehousesOptions.map(w => w.value != 'All' ? this.warehouseDefaultOptions.push(w) : false)

                }
                else {
                    const form = []
                    this.warehousesOptions.map(c => {
                        this.form.warehouses.map(a => {
                            if(a == c.value) {
                                form.push(c)
                            }
                        })
                    })

                    this.warehouseDefaultOptions = form
                }
            },
            dissapear(){
                alert('ok')
                // document.getElementsByClassName("a").style.display = "none";
                // this.a = false
            }
        },
        mounted(){
            this.fetchData()
        },
	}
</script>

<style>

</style>